import Box from "@mui/material/Box";
import * as React from "react";

import { MetadataForm, MetadataView } from "@/shared/components";
import { AutocompleteType } from "@/shared/components/TagAndMetadataAutocomplete";
import { UpdateActionRequest } from "@/shared/domain/actions/ActionRecord";

interface UpdateActionMetadataProps {
  initialMetadata: Record<string, string>;
  onChange: (updates: UpdateActionRequest) => void;
  setErrorText: (arg: string) => void;
  canEdit?: boolean;
}

export function UpdateActionMetadata({
  initialMetadata,
  onChange,
  setErrorText,
  canEdit,
}: UpdateActionMetadataProps) {
  const [metadata, setMetadata] =
    React.useState<Record<string, unknown>>(initialMetadata);

  const updateMetadata = (updates: UpdateActionRequest) => {
    setErrorText("");
    onChange(updates);
  };

  const metadataAdded = (key: string, value: unknown) => {
    if (key && value) {
      const metadataClone = {
        ...metadata,
        [key]: value,
      };
      setMetadata(metadataClone);
      updateMetadata({
        metadata_changeset: {
          put_fields: { [key]: value },
        },
      });
    }
  };

  return (
    <Box>
      <MetadataView
        /*
          TODO(ENG-1999): The create action endpoint doesn't support
          nested JSON-valued metadata, so disallow the JSON editor for now.
        */
        jsonMetadataDisabled
        metadata={metadata}
        disabled={!canEdit}
        onChange={(metadata: Record<string, unknown>, diff) => {
          setMetadata(metadata);
          let removeFields: string[] | undefined = undefined;
          let putFields: Record<string, unknown> | undefined = undefined;
          if (diff?.keysDeleted && diff.keysDeleted.length > 0) {
            removeFields = diff.keysDeleted;
          }
          if (diff?.keysUpdated && diff.keysUpdated.length > 0) {
            putFields = {};
            for (const k of diff.keysUpdated) {
              putFields[k] = metadata[k];
            }
          }
          if (removeFields || putFields) {
            updateMetadata({
              metadata_changeset: {
                remove_fields: removeFields,
                put_fields: putFields,
              },
            });
          }
        }}
      />
      <MetadataForm
        metadata={metadata}
        autocompleteType={AutocompleteType.ActionMetadataKeys}
        onAddMetadata={metadataAdded}
        disabled={!canEdit}
        jsonMetadataDisabled
      />
    </Box>
  );
}
